import { Component, EventEmitter, OnDestroy, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { clearUnreadNotificationsList } from 'src/app/data/store/actions/notifications.action';
import { befreeUrlValues } from 'src/app/shared/constants';
import { TextSizes, TextType } from 'src/app/shared/enums';
import { TextComponent } from '../text/text.component';
import { ImageComponent } from '../image/image.component';
import { IonicModule } from '@ionic/angular';
import { IonScrollBarDirective } from '../../directives/ion-scroll-bar/ion-scroll-bar.directive';
import { CommonNotificationsListComponent } from '../common-notifications-list/common-notifications-list.component';
@Component({
  selector: 'app-notifications-modal',
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.scss'],
  imports: [
    TextComponent,
    ImageComponent,
    IonicModule,
    IonScrollBarDirective,
    CommonNotificationsListComponent,
  ],
})
export class NotificationsModalComponent implements OnDestroy {
  private _router = inject(Router);
  private _store = inject(Store);

  @Output() emitOpenNotificationPage = new EventEmitter<void>();

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;

  public goToNotificationPage() {
    this._router.navigate([
      befreeUrlValues.dashboard,
      befreeUrlValues.notifications,
      befreeUrlValues.all,
    ]);
    this.emitOpenNotificationPage.emit();
  }

  ngOnDestroy(): void {
    this._store.dispatch(clearUnreadNotificationsList());
  }
}
